"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.USER_COMPANY_USER_NOTIFICATION_CHANNELS_ENDPOINT = {
    createUserNotificationChannel: '/user-company{{version}}/users/{{userUuid}}/notification-channels',
    createProfileNotificationChannel: '/user-company{{version}}/user-profiles/{{userProfileUuid}}/notification-channels',
    updateUserNotificationChannel: '/user-company{{version}}/user-notification-channels/{{notificationChannelUuid}}',
};
